<div class="submission-bar">
  <div>
    <button class="btn-white-bggrey clear-button" (click)="backAction()">{{ backButtonText }}</button>
  </div>

  <div>
    <button class="btn-white-bggrey clear-button" (click)="clearAction()">{{ clearButtonText }}</button>

    <button class="btn-primary-yellow" [disabled]="submitButtonDisabled" (click)="submitAction()">
      {{ submitButtonText }}
    </button>
  </div>
</div>
